module.exports = __webpack_public_path__ + "static/back_event_04-c5ce8961abe5c0b932bf8bfdf2ab6077.jpg";